import React from "react";
import "./payment.layout.sass";
import { Link } from "react-router-dom";
import PaymentFalse from "../../assets/image/PaymentFalse.png";
import PaymentTrue from "../../assets/image/PaymentTrue.png";
import GridLoader from "react-spinners/GridLoader";
import { css } from "@emotion/react";
import { connect } from "react-redux";
import { SetProduct } from "../../redux/site/site.actions";
import UserTypes from "../../redux/users/users.types";

const PaymentLayout = ({ Data, code, destroyProduct }) => {
  const override = css`
    display: block;
    margin: 40px auto;
    border-color: red;
    position: relative;
  `;
  if (Data) {
    if (Data.status === "success") {
      destroyProduct();
    }
  }

  return (
    <div className="callBack-result">
      {Data ? (
        <div className="main-div">
          <div className="callback">
            <div className="header-form">
              {Data.status === "success" ? (
                <img src={PaymentTrue} alt="Xitonix payment" />
              ) : (
                <img src={PaymentFalse} alt="Xitonix payment" />
              )}
            </div>
            <div className="callback-content">
              <h4 className="callback-title">{Data.name} عزیز،</h4>
              {Data.status === "success" ? (
                <div>
                  <h5>پرداخت شما با موفقیت انجام شد.</h5>
                  <p>
                    مبلغ پرداخت شده : <strong>{Data.totalPrice}</strong>
                  </p>
                  <p>
                    کد پیگیری : <strong>{code}</strong>
                  </p>
                </div>
              ) : (
                <div>
                  <h5>متاسفانه پرداخت شما موفقیت آمیز نبود.</h5>
                  <p>
                    درصورتی که مبلغ از حساب شما کسر گردیده تا ۷۲ ساعت آتی به
                    حساب شما باز میگردد.
                  </p>
                </div>
              )}
            </div>
            <br />
            <Link to="/">
              <button class="callback-btn callback-btn-success">
                بازگشت به صفحه اصلی
              </button>
            </Link>
          </div>
        </div>
      ) : (
        <GridLoader css={override} size={15} margin={8} color="#FF8F3C" />
      )}
    </div>
  );
};
const mapDispatchToProps = (dispatch) => ({
  destroyProduct: () => dispatch({ type: UserTypes.DESTROY_PRODUCT }),
});
export default connect(null, mapDispatchToProps)(PaymentLayout);
